import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportIconCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 30,
		height: 30,
		rx: 15,
		fill: "#1c70e8"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 17.5462L17.5455 15.0007H15.6364V9.27344H14.3636V15.0007H12.4545L15 17.5462ZM20.7273 9.27344H16.9091V10.5398H20.7273V19.468H9.27273V10.5398H13.0909V9.27344H9.27273C8.57273 9.27344 8 9.84616 8 10.5462V19.4553C8 20.1553 8.57273 20.728 9.27273 20.728H20.7273C21.4273 20.728 22 20.1553 22 19.4553V10.5462C22 9.84616 21.4273 9.27344 20.7273 9.27344ZM15 17.5462L17.5455 15.0007H15.6364V9.27344H14.3636V15.0007H12.4545L15 17.5462ZM20.7273 9.27344H16.9091V10.5398H20.7273V19.468H9.27273V10.5398H13.0909V9.27344H9.27273C8.57273 9.27344 8 9.84616 8 10.5462V19.4553C8 20.1553 8.57273 20.728 9.27273 20.728H20.7273C21.4273 20.728 22 20.1553 22 19.4553V10.5462C22 9.84616 21.4273 9.27344 20.7273 9.27344Z",
		fill: "white"
	})]
});
export default SvgImportIconCircle;
